import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {AutoSizer} from 'react-virtualized';
import {Animation, DataGrid} from '@perion-undertone/ut-react-common';
import getBlockedAdvertisersGridSchema from './blockedAdvertisersGridSchema';
import GridNoRowsTemplate from '../../../GridNoRowsTemplate';
import {appStates} from '../imports';
import {adaptColumnsForV7} from '../../../../utils/reactDataGridV7';

const CLASS_NAMES = {
    CONTAINER: 'block-advertisers-grid-container',
    INNER_CONTAINER: 'block-advertisers-grid-inner-container',
};

// One row identity for both shapes (blocked advertiser by id, or advertiser
// domain by URL). The supply-source id is included so the same advertiser
// blocked at multiple supply sources renders as distinct rows.
const rowKeyGetter = (row) => {
    if (!row) { return ''; }
    const supplySource = row.publishersSupplySourcesId == null ? '' : row.publishersSupplySourcesId;
    if (row.advertiserId != null) {
        return `adv-${row.advertiserId}-${supplySource}`;
    }
    if (row.advertiserUrl) {
        return `url-${row.advertiserUrl}-${supplySource}`;
    }
    return '';
};

class BlockedAdvertisersGrid extends Component {
    filterBlockedAdvertisers = (blockedAdvertisers, searchTerm, isAdvertiserDomains) => {
        const data = blockedAdvertisers.data;
        if (!data) {
            return [];
        }
        if (searchTerm) {
            const lcaseTerm = searchTerm.toString().toLowerCase();
            if (isAdvertiserDomains) {
                return data.filter(blockedAdv =>
                    blockedAdv.advertiserUrl.toLowerCase().includes(lcaseTerm))
            }
            return data.filter(blockedAdv =>
                blockedAdv.advertiserId.toString().includes(lcaseTerm) ||
                blockedAdv.Advertiser.name.toLowerCase().includes(lcaseTerm))
        }
        return data;
    }

    render() {
        const {blockedAdvertisers, isPublisherLevel, isBulkBlock, publishersSupplySourcesIds, isAdvertiserDomains} = this.props;
        const searchTerm = isAdvertiserDomains ? this.props.searchTerm : blockedAdvertisers.searchTerm;
        const rowSource = this.filterBlockedAdvertisers(blockedAdvertisers, searchTerm, isAdvertiserDomains);
        const columns = adaptColumnsForV7(
            getBlockedAdvertisersGridSchema(isPublisherLevel, isBulkBlock, publishersSupplySourcesIds, isAdvertiserDomains)
        );

        return (<div className={CLASS_NAMES.CONTAINER}>
            {appStates.LOADED === blockedAdvertisers.state
                ? (<div className={CLASS_NAMES.INNER_CONTAINER}>
                    <AutoSizer>
                        {({height, width}) => (
                            <DataGrid columns={columns}
                                      rows={rowSource}
                                      rowKeyGetter={rowKeyGetter}
                                      rowHeight={56}
                                      headerRowHeight={41}
                                      defaultHeight={height}
                                      defaultWidth={width}
                                      emptyRowsView={GridNoRowsTemplate}
                            />
                        )}
                    </AutoSizer>
                </div>)
                : <Animation type="chasing"
                             height={100}
                             width={100}
                             rendererSettings={{preserveAspectRatio: 'xMaxYMax'}}
                             hookId='blocked-advertisers-loading'
                />}
        </div>)
    }
}

BlockedAdvertisersGrid.propTypes = {
    blockedAdvertisers: PropTypes.object,
    publishersSupplySourcesId: PropTypes.number,
    publisherId: PropTypes.number,
    isPublisherLevel: PropTypes.bool,
    isBulkBlock: PropTypes.bool,
    publishersSupplySourcesIds: PropTypes.array,
    isAdvertiserDomains: PropTypes.bool,
    searchTerm: PropTypes.string
};

export default BlockedAdvertisersGrid;
